import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Login from '@/pages/Login';
import Signup from '@/pages/Signup';
import Dashboard from '@/pages/Dashboard';
import Businesses from '@/pages/Businesses';
import Customers from '@/pages/Customers';
import Invoices from '@/pages/Invoices';
import InvoiceCreate from '@/pages/InvoiceCreate';
import InvoiceDetail from '@/pages/InvoiceDetail';
import CustomerProfile from '@/pages/CustomerProfile';
import RecurringSchedules from '@/pages/RecurringSchedules';
import Settings from '@/pages/Settings';
import Layout from '@/components/Layout';
import InvoiceEdit from './pages/InvoiceEdit';

const App = () => {
  const [token, setToken] = useState(localStorage.getItem('token'));

  const handleLogin = (newToken) => {
    localStorage.setItem('token', newToken);
    setToken(newToken);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setToken(null);
  };

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={!token ? <Login onLogin={handleLogin} /> : <Navigate to="/" />}
          />
          <Route
            path="/"
            element={token ? <Layout onLogout={handleLogout} /> : <Navigate to="/login" />}
          >
            <Route index element={<Dashboard />} />
            <Route path="businesses" element={<Businesses />} />
            <Route path="customers" element={<Customers />} />
            <Route path="/invoices/:id/edit" element={<InvoiceEdit />} />
            <Route path="customers/:customerId" element={<CustomerProfile />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="invoices/new" element={<InvoiceCreate />} />
            <Route path="invoices/:invoiceId" element={<InvoiceDetail />} />
            <Route path="recurring" element={<RecurringSchedules />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </>
  );
};

export default App;